import { Component, OnDestroy, OnInit } from "@angular/core"
import { SearchInfoModel } from "../../../models/searchInfo.model"
import { FacetingService } from "../../../services/faceting.service"
import { SearchingService } from "../../../services/searching.service"
import { EduComponent } from "../../../utils/eduComponent"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    selector: "app-mobile-filter-modal",
    templateUrl: "./mobile-filter-modal.component.html",
    styleUrls: ["./mobile-filter-modal.component.scss"],
    standalone: false,
})
export class MobileFilterModalComponent extends EduComponent implements OnInit, OnDestroy {
    public totalCount: number = 0
    public appliedFiltersCount: number = 0
    public searchInfo: SearchInfoModel

    public get _totalCount() {
        return this.totalCount
    }

    public set _totalCount(value) {
        this.totalCount = value
    }

    constructor(
        public ngbActiveModal: NgbActiveModal,
        public searchingService: SearchingService,
        public facetingService: FacetingService
    ) {
        super()
    }

    filtersChanged = false
    selectedFiltersOldVal = null

    public ngOnInit() {
        this.addSub(
            this.searchingService.resultsCount.subscribe((count) => (this.totalCount = count))
        )
        this.addSub(
            this.facetingService.filtersChanged.subscribe((data) => {
                if (data) {
                    this.appliedFiltersCount = data.length
                    this.filtersChanged = this.hasFiltersChanges(data)
                }
            })
        )
    }

    protected hasFiltersChanges(data): boolean {
        if (this.selectedFiltersOldVal === null) {
            this.selectedFiltersOldVal = data
        }

        return (
            data.length !== this.selectedFiltersOldVal.length ||
            !this.selectedFiltersOldVal.every((el) => data.includes(el))
        )
    }
}
